import { ChatEditorInput } from 'vscode/vscode/vs/workbench/contrib/chat/browser/chatEditorInput';
import { IEditorGroupsService } from 'vscode/vscode/vs/workbench/services/editor/common/editorGroupsService.service';
import { IEditorService } from 'vscode/vscode/vs/workbench/services/editor/common/editorService.service';

async function clearChatEditor(accessor) {
    const editorService = accessor.get(IEditorService);
    const editorGroupsService = accessor.get(IEditorGroupsService);
    const chatEditorInput = editorService.activeEditor;
    if (chatEditorInput instanceof ChatEditorInput) {
        await editorService.replaceEditors([{
                editor: chatEditorInput,
                replacement: { resource: ChatEditorInput.getNewEditorUri(), options: { pinned: true } }
            }], editorGroupsService.activeGroup);
    }
}

export { clearChatEditor };
